module.exports = __webpack_public_path__ + "static/commerce2x-pwa-c2b05867c736aa34362ef66da42476d4.png";